/**
 * TranslationButton: 자막/번역 사이드바 토글 (푸터).
 *
 * 기획서:
 * - ONE AI 배포자이거나, 해당 방이 회의 생성자 크레딧 소모 타입(MASTER)이면 노출
 * - 자막/번역 둘 다 OFF → 클릭 시 설정 패널 열기
 * - 자막 or 번역 ON → 클릭 시 히스토리 패널 열기
 * - 이미 열려있으면 → 사이드바 닫기
 *
 * 마크업 참조: translate_1.html의 icoTranslation
 */
import React from 'react';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { uiActions } from '@/store/slices/uiSlice';
import { translationActions } from '@/store/slices/translationSlice';

const TranslationButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const ui = useAppSelector((s) => s.ui);
  const translation = useAppSelector((s) => s.translation);
  const creditMode = useAppSelector((s) => s.local.creditMode);

  // ONE AI 배포자이거나 회의 생성자 크레딧 소모 타입(MASTER)이면 노출
  if (!translation.isAbleOneAI && creditMode !== 'MASTER') return null;

  const isActive = ui.openSideBar && ui.sidebarContent === 'translation';

  const handleClick = () => {
    if (isActive) {
      // 이미 열려있으면 닫기
      dispatch(uiActions.setOpenSideBar(false));
      return;
    }

    // 자막/번역 둘 다 OFF → 설정 패널
    // 자막 or 번역 ON → 히스토리 패널
    const shouldOpenSettings =
      !translation.isCaptionEnabled && !translation.isTranslateEnabled;
    dispatch(translationActions.setSettingMode(shouldOpenSettings));
    dispatch(uiActions.setSidebarContent('translation'));
  };

  return (
    <div className="newHeader_btnItem">
      <button
        type="button"
        className={`newHeader_btn${isActive ? ' active' : ''}`}
        onClick={handleClick}
      >
        <span className="newHeader_btnIcon icoTranslation" />
        <p className="newHeader_btnText">자막/번역</p>
      </button>
    </div>
  );
};

export default TranslationButton;
